import { useState } from 'react';
import { accountTypesOptions } from '../../../../../../shared/data/clientDetailsOptions';

export default function useDataStoreState({ generalData, client }) {
    const [dataStore, setDataStore] = useState({
        api_url: generalData?.api_url || client?.api_url || '',
        ssn_required: generalData?.ssn_required,
        email_required: generalData?.email_required,
        app_locale: generalData?.app_locale,
        country_code: generalData?.country_code,
        is_criipto_integration_enabled:
            generalData?.is_criipto_integration_enabled,
        is_bank_id_login_enabled: generalData?.is_bank_id_login_enabled,
        is_login_email_form_enabled: generalData?.is_login_email_form_enabled,
        is_2fa_enabled: generalData?.is_2fa_enabled,
        is_show_powered_by_defentry_logo:
            generalData?.is_show_powered_by_defentry_logo,
        criipto_buttons_styles:
            generalData?.criipto_buttons_styles ?? 'default',
        ssn_verification_only: generalData?.ssn_verification_only,
        company_info: {
            se: {
                company_name: generalData?.company_info?.se?.company_name || '',
                service_name: generalData?.company_info?.se?.service_name || '',
                title_service_name:
                    generalData?.company_info?.se?.title_service_name ||
                    generalData?.company_info?.se?.service_name ||
                    '',
                company_full_name:
                    generalData?.company_info?.se?.company_full_name || '',
            },
            no: {
                company_name: generalData?.company_info?.no?.company_name || '',
                service_name: generalData?.company_info?.no?.service_name || '',
                title_service_name:
                    generalData?.company_info?.no?.title_service_name ||
                    generalData?.company_info?.no?.service_name ||
                    '',
                company_full_name:
                    generalData?.company_info?.no?.company_full_name || '',
            },
            fi: {
                company_name: generalData?.company_info?.fi?.company_name || '',
                service_name: generalData?.company_info?.fi?.service_name || '',
                title_service_name:
                    generalData?.company_info?.fi?.title_service_name ||
                    generalData?.company_info?.fi?.service_name ||
                    '',
                company_full_name:
                    generalData?.company_info?.fi?.company_full_name || '',
            },
            dk: {
                company_name: generalData?.company_info?.dk?.company_name || '',
                service_name: generalData?.company_info?.dk?.service_name || '',
                title_service_name:
                    generalData?.company_info?.dk?.title_service_name ||
                    generalData?.company_info?.dk?.service_name ||
                    '',
                company_full_name:
                    generalData?.company_info?.dk?.company_full_name || '',
            },
            is: {
                company_name: generalData?.company_info?.is?.company_name || '',
                service_name: generalData?.company_info?.is?.service_name || '',
                title_service_name:
                    generalData?.company_info?.is?.title_service_name ||
                    generalData?.company_info?.is?.service_name ||
                    '',
                company_full_name:
                    generalData?.company_info?.is?.company_full_name || '',
            },
        },
        account_types: accountTypesOptions.map((el) => el.id),
        logos_sizes: {
            web_app: {
                logo: {
                    se: {
                        width:
                            generalData?.logos_sizes?.web_app?.logo?.se
                                ?.width || '',
                        height:
                            generalData?.logos_sizes?.web_app?.logo?.se
                                ?.height || '',
                    },
                    no: {
                        width:
                            generalData?.logos_sizes?.web_app?.logo?.no
                                ?.width || '',
                        height:
                            generalData?.logos_sizes?.web_app?.logo?.no
                                ?.height || '',
                    },
                    fi: {
                        width:
                            generalData?.logos_sizes?.web_app?.logo?.fi
                                ?.width || '',
                        height:
                            generalData?.logos_sizes?.web_app?.logo?.fi
                                ?.height || '',
                    },
                    dk: {
                        width:
                            generalData?.logos_sizes?.web_app?.logo?.dk
                                ?.width || '',
                        height:
                            generalData?.logos_sizes?.web_app?.logo?.dk
                                ?.height || '',
                    },
                    is: {
                        width:
                            generalData?.logos_sizes?.web_app?.logo?.is
                                ?.width || '',
                        height:
                            generalData?.logos_sizes?.web_app?.logo?.is
                                ?.height || '',
                    },
                },
                // mark: {...},
                // email: {...},
                // favicon: {...},
            },
            crm: {
                logo: {
                    width: generalData?.logos_sizes?.crm?.logo?.width || '',
                    height: generalData?.logos_sizes?.crm?.logo?.height || '',
                },
                // mark: {...},
                // email: {...},
                // favicon: {...},
            },
        },
        countries_localizations: {
            se: {
                web_site_url:
                    generalData?.countries_localizations?.se?.web_site_url ||
                    '',
                terms_conditions_url:
                    generalData?.countries_localizations?.se
                        ?.terms_conditions_url || '',
                support_page_url:
                    generalData?.countries_localizations?.se
                        ?.support_page_url || '',
                blog_page_url:
                    generalData?.countries_localizations?.se?.blog_page_url ||
                    '',
                privacy_policy_url:
                    generalData?.countries_localizations?.se
                        ?.privacy_policy_url || '',
                web_app_url:
                    generalData?.countries_localizations?.se?.web_app_url || '',
                crm_url:
                    generalData?.countries_localizations?.se?.crm_url || '',
                facebook_url:
                    generalData?.countries_localizations?.se?.facebook_url ||
                    '',
                app_store_url:
                    generalData?.countries_localizations?.se?.app_store_url ||
                    '',
                google_play_url:
                    generalData?.countries_localizations?.se?.google_play_url ||
                    '',
                twitter_url:
                    generalData?.countries_localizations?.se?.twitter_url || '',
                linkedIn_url:
                    generalData?.countries_localizations?.se?.linkedIn_url ||
                    '',
                contact_us_url:
                    generalData?.countries_localizations?.se?.contact_us_url ||
                    '',
                contact_us_email:
                    generalData?.countries_localizations?.se
                        ?.contact_us_email || '',
                instagram_url:
                    generalData?.countries_localizations?.se?.instagram_url ||
                    '',
                youtube_url:
                    generalData?.countries_localizations?.se?.youtube_url || '',
            },
            no: {
                web_site_url:
                    generalData?.countries_localizations?.no?.web_site_url ||
                    '',
                terms_conditions_url:
                    generalData?.countries_localizations?.no
                        ?.terms_conditions_url || '',
                support_page_url:
                    generalData?.countries_localizations?.no
                        ?.support_page_url || '',
                blog_page_url:
                    generalData?.countries_localizations?.no?.blog_page_url ||
                    '',
                privacy_policy_url:
                    generalData?.countries_localizations?.no
                        ?.privacy_policy_url || '',
                web_app_url:
                    generalData?.countries_localizations?.no?.web_app_url || '',
                crm_url:
                    generalData?.countries_localizations?.no?.crm_url || '',
                facebook_url:
                    generalData?.countries_localizations?.no?.facebook_url ||
                    '',
                app_store_url:
                    generalData?.countries_localizations?.no?.app_store_url ||
                    '',
                google_play_url:
                    generalData?.countries_localizations?.no?.google_play_url ||
                    '',
                twitter_url:
                    generalData?.countries_localizations?.no?.twitter_url || '',
                linkedIn_url:
                    generalData?.countries_localizations?.no?.linkedIn_url ||
                    '',
                contact_us_url:
                    generalData?.countries_localizations?.no?.contact_us_url ||
                    '',
                contact_us_email:
                    generalData?.countries_localizations?.no
                        ?.contact_us_email || '',
                instagram_url:
                    generalData?.countries_localizations?.no?.instagram_url ||
                    '',
                youtube_url:
                    generalData?.countries_localizations?.no?.youtube_url || '',
            },
            fi: {
                web_site_url:
                    generalData?.countries_localizations?.fi?.web_site_url ||
                    '',
                terms_conditions_url:
                    generalData?.countries_localizations?.fi
                        ?.terms_conditions_url || '',
                support_page_url:
                    generalData?.countries_localizations?.fi
                        ?.support_page_url || '',
                blog_page_url:
                    generalData?.countries_localizations?.fi?.blog_page_url ||
                    '',
                privacy_policy_url:
                    generalData?.countries_localizations?.fi
                        ?.privacy_policy_url || '',
                web_app_url:
                    generalData?.countries_localizations?.fi?.web_app_url || '',
                crm_url:
                    generalData?.countries_localizations?.fi?.crm_url || '',
                facebook_url:
                    generalData?.countries_localizations?.fi?.facebook_url ||
                    '',
                app_store_url:
                    generalData?.countries_localizations?.fi?.app_store_url ||
                    '',
                google_play_url:
                    generalData?.countries_localizations?.fi?.google_play_url ||
                    '',
                twitter_url:
                    generalData?.countries_localizations?.fi?.twitter_url || '',
                linkedIn_url:
                    generalData?.countries_localizations?.fi?.linkedIn_url ||
                    '',
                contact_us_url:
                    generalData?.countries_localizations?.fi?.contact_us_url ||
                    '',
                contact_us_email:
                    generalData?.countries_localizations?.fi
                        ?.contact_us_email || '',
                instagram_url:
                    generalData?.countries_localizations?.fi?.instagram_url ||
                    '',
                youtube_url:
                    generalData?.countries_localizations?.fi?.youtube_url || '',
            },
            dk: {
                web_site_url:
                    generalData?.countries_localizations?.dk?.web_site_url ||
                    '',
                terms_conditions_url:
                    generalData?.countries_localizations?.dk
                        ?.terms_conditions_url || '',
                support_page_url:
                    generalData?.countries_localizations?.dk
                        ?.support_page_url || '',
                blog_page_url:
                    generalData?.countries_localizations?.dk?.blog_page_url ||
                    '',
                privacy_policy_url:
                    generalData?.countries_localizations?.dk
                        ?.privacy_policy_url || '',
                web_app_url:
                    generalData?.countries_localizations?.dk?.web_app_url || '',
                crm_url:
                    generalData?.countries_localizations?.dk?.crm_url || '',
                facebook_url:
                    generalData?.countries_localizations?.dk?.facebook_url ||
                    '',
                app_store_url:
                    generalData?.countries_localizations?.dk?.app_store_url ||
                    '',
                google_play_url:
                    generalData?.countries_localizations?.dk?.google_play_url ||
                    '',
                twitter_url:
                    generalData?.countries_localizations?.dk?.twitter_url || '',
                linkedIn_url:
                    generalData?.countries_localizations?.dk?.linkedIn_url ||
                    '',
                contact_us_url:
                    generalData?.countries_localizations?.dk?.contact_us_url ||
                    '',
                contact_us_email:
                    generalData?.countries_localizations?.dk
                        ?.contact_us_email || '',
                instagram_url:
                    generalData?.countries_localizations?.dk?.instagram_url ||
                    '',
                youtube_url:
                    generalData?.countries_localizations?.dk?.youtube_url || '',
            },
            is: {
                web_site_url:
                    generalData?.countries_localizations?.is?.web_site_url ||
                    '',
                terms_conditions_url:
                    generalData?.countries_localizations?.is
                        ?.terms_conditions_url || '',
                support_page_url:
                    generalData?.countries_localizations?.is
                        ?.support_page_url || '',
                blog_page_url:
                    generalData?.countries_localizations?.is?.blog_page_url ||
                    '',
                privacy_policy_url:
                    generalData?.countries_localizations?.is
                        ?.privacy_policy_url || '',
                web_app_url:
                    generalData?.countries_localizations?.is?.web_app_url || '',
                crm_url:
                    generalData?.countries_localizations?.is?.crm_url || '',
                facebook_url:
                    generalData?.countries_localizations?.is?.facebook_url ||
                    '',
                app_store_url:
                    generalData?.countries_localizations?.is?.app_store_url ||
                    '',
                google_play_url:
                    generalData?.countries_localizations?.is?.google_play_url ||
                    '',
                twitter_url:
                    generalData?.countries_localizations?.is?.twitter_url || '',
                linkedIn_url:
                    generalData?.countries_localizations?.is?.linkedIn_url ||
                    '',
                contact_us_url:
                    generalData?.countries_localizations?.is?.contact_us_url ||
                    '',
                contact_us_email:
                    generalData?.countries_localizations?.is
                        ?.contact_us_email || '',
                instagram_url:
                    generalData?.countries_localizations?.is?.instagram_url ||
                    '',
                youtube_url:
                    generalData?.countries_localizations?.is?.youtube_url || '',
            },
        },
    });

    return [dataStore, setDataStore];
}
